import ServiceTypeSelect from './ServiceTypeSelect.vue';
import serviceTypeMixin from './mixin';

export { serviceTypeMixin };
export default ServiceTypeSelect;
